// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Yi-z","heading":"Zi-z"};